module.exports = __webpack_public_path__ + "img/avatar5.dcd72086.png";